import React, {useEffect, useState} from 'react'
import Tools from '../../cvp-webgames-core/Misc/Tools';
import {constants} from '../../misc/constants';
import {generalAudioCaching, PageType, parseDynamicHtml, setFocus, TextHtmlTagType} from '../../misc/tools';
import {BaseConfig} from '../BaseConfig';
import Button2 from '../general/button2';
import PopUp2 from '../general/pop-up2';
import {UIProperties} from '../../cvp-webgames-core/Components/ui/UIProperties';
import "./question-type1-ui.css"
import {
    coreGeneralQuestionUIBaseImplementation,
    GeneralQuestionUIConfig,
    GeneralQuestionUIConfigOption
} from '../../cvp-webgames-core/Components/ui/react/core-general-question-ui';
import ReplayContentUI from './replay-content-ui';
import { green } from '@mui/material/colors';

var cacheShowCorrectAnswer = false;

const QuestionType1UI = (props: UIProperties<QuestionType1UIConfig>) => {
	const baseImplementation = coreGeneralQuestionUIBaseImplementation.getImplementation(props.parameters);
    const selectedOptionIndices: number[] = baseImplementation.getSelectedOptions();
    const [forcedUpdate, setForcedUpdate] = useState(0);
    const [showCorrectAnswers, setShowCorrectAnswers] = useState(cacheShowCorrectAnswer);
    const singleOptionWidth = props.parameters.options.length === 6 ? 210 : 270;


	useEffect(() => {
		if(forcedUpdate === 0) {
            const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.music_marimba_chord_01).src;
			Tools.playOneShotSound(url);

            baseImplementation.init(() => {
                setForcedUpdate(forcedUpdate + 1);
            })
        }
	}, []);

    const renderDescription = () => {
        return (
            <div className='question-type1-ui-sub-container-desc-container' style={{
                position: 'relative',
                top: '13px'
            }}>
                <div
                    className='center-element-horizontal main-content-inner question-type1-ui-sub-container-desc-container-inner'>
                    {selectedOptionIndices.length > 0 ? <p className='center-element-horizontal black-text' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.options[selectedOptionIndices[selectedOptionIndices.length - 1]].description) }}></p> : (null)}
                </div>
            </div>
        );
    }

	const onQuestionSubmitted = () => {
        baseImplementation.onQuestionSubmitted()
        const selectedOptions = props.parameters.options.map((option: GeneralQuestionUIConfigOption, indx: number) => {
            return selectedOptionIndices.indexOf(indx) !== -1 ? option : undefined
        }).filter(o => typeof o !== 'undefined');
		props.parameters.onSubmitClicked(props.parameters.options, selectedOptions, props.parameters);
	}

    const showDebugMenu = () => {
        return (
            <div style={{
                position: 'absolute',
                top: '120px',
                left: '1050px',
                pointerEvents: 'all',
                cursor: 'pointer',
                zIndex: '1'
            }}>
                <button onClick={() => {
                    cacheShowCorrectAnswer = !showCorrectAnswers;
                    setShowCorrectAnswers(!showCorrectAnswers);
                }}>{'(Click This To Toggle Correct Answers)'}</button>
            </div>
        );
    }

    setTimeout(() => {
        const options = document.querySelectorAll('.question-type1-ui-sub-container-question-single-option');
        const parent = options[0].parentElement;
        for(var indx = 0; indx < options.length; indx++) {
            options[indx].setAttribute('style', `width: ${singleOptionWidth}px;`)
        }
    }, 0);

    return (
        <div className="modal-disable-select question-type1-ui-container" style={{}}>
            <div className='gauges'>
                
            </div>
            {constants.debugQuestions ? showDebugMenu() : null}
            <div aria-label='Question' className={`question-type1-ui-inner-container center-element ${constants.mainContent508Id}`}>
                <PopUp2
                    titleLeft={constants.projectTitle}
                    idForTitleRight='question-type-1-content-top'
                    titleRight={props.parameters.title}
                    subtitleRight={props.parameters.subtitle}
                    onRenderContent={() => {
                        return (
                            <div>
                                <div className='question-type1-ui-sub-container main-content-inner center-element-horizontal'>
                                    <div
                                        className='center-element-horizontal question-type1-ui-sub-container-question-title'>
                                        <p className='center-element black-text'>{props.parameters.questionTitle}</p>
                                    </div>
                                    <div className="question-type1-ui-sub-container-question-options" style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}>
                                        {props.parameters.options.map((option: GeneralQuestionUIConfigOption, index: number) => {
                                            const onClick = () => {
                                                baseImplementation.onOptionSelected(option, index, () => {
                                                    setForcedUpdate(forcedUpdate + 1);
                                                    if(!props.parameters.multipleChoice && option.isSelected) {
                                                        setFocus('question-option-submit');
                                                    }
                                                 })
                                            }
                                            return (
                                                <div className='question-type1-ui-sub-container-question-single-option' style={{
                                                    width: `220px`,
                                                    position: 'relative'
                                                }} key={Tools.generateGuid()}>
                                                    <Button2 width='100%'
                                                            idFor508={'question-type-1-content-top'}
                                                             height='100%'
                                                             backgroundColor='rgb(55, 70, 104)'
                                                             hoverBgColor={constants.design.hoverColor1}
                                                             style={{
                                                                overflow: 'hidden'
                                                             }}
                                                             onClick={() => {
                                                                 onClick();
                                                             }}
                                                             onRenderContent={() => {
                                                                 return (
                                                                    <div style={{
                                                                        position: 'relative',
                                                                        // height: '160px',
                                                                        height: '100%',
                                                                        minHeight: '100px',
                                                                        overflow: 'hidden'
                                                                    }}>
                                                                        
                                                                        <div style={{
                                                                            position: 'relative',
                                                                            width: '100%',
                                                                            height: '30px',
                                                                            top: '0',
                                                                            left: '0',
                                                                            borderRadius: '5px',
                                                                            visibility: selectedOptionIndices.indexOf(index) !== -1 ? 'visible' : 'hidden'
                                                                        }}>
                                                                            <div style={{
                                                                                height: '30px',
                                                                                backgroundColor: selectedOptionIndices.indexOf(index) !== -1 ? 'green' : 'white',
                                                                            }}></div>
                                                                            <div style={{
                                                                                // left: (() => {
                                                                                //     var initial = props.parameters.options.length === 4 ? 276 : 104;
                                                                                //     var val = initial + (singleOptionWidth) * selectedOptionIndex;
                                                                                //     return val + 'px'
                                                                                // })()
                                                                                left: '50%',
                                                                                top: '-7px',
                                                                                /* height: 30px; */
                                                                                transform: 'translateX(-50%)'
                                                                            }} className='question-type1-ui-arrow-container'>
                                                                                <i className='question-type1-ui-arrow'></i>
                                                                            </div>
                                                                        </div>
                                                                        <form style={{
                                                                                position: 'absolute',
                                                                                left: '10px',
                                                                                top: '-6px',
                                                                                pointerEvents: 'none'
                                                                            }}>
                                                                            <input onKeyUp={(key: any) => {
                                                                                    if(key.keyCode === 13) {
                                                                                        onClick();
                                                                                    }
                                                                                }} type={!props.parameters.multipleChoice ? "radio" : "checkbox"} defaultChecked={selectedOptionIndices.indexOf(index) !== -1} />
                                                                        </form>
                                                                        <div style={{
                                                                            width: '100%',
                                                                            position: 'relative'
                                                                        }}>
                                                                            <p style={{
                                                                                // position: 'relative',
                                                                                // top: '50%',
                                                                                // transform: 'translateY(-50%)',
                                                                                color: (selectedOptionIndices.indexOf(index) !== -1 ? 'black' : 'white'),
                                                                                width: '100%',
                                                                                left: '0'
                                                                            }} className='option-text'>{option.title}</p>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                 )
                                                             }}
                                                             isSelected={baseImplementation.isOptionSelected(index)}
                                                             ariaLabel={option.title + (selectedOptionIndices.indexOf(index) !== -1 ? '. selected' : '. unselected') + '. ' + option.description}></Button2>
                                                
                                                    {showCorrectAnswers && option.isCorrect? <p style={{
                                                        color: 'green',
                                                        width: `235px`,
                                                        position: 'absolute',
                                                        top: '65px',
                                                        left: ((15 + (235) * index)) + 'px'
                                                    }}>
                                                        (Correct)
                                                    </p>: (null)}
                                                </div>

                                            )
                                        })}
                                    </div>
                                    {selectedOptionIndices.length > 0 ? renderDescription() : null}
                                </div>
                                <div
                                    className='center-element-horizontal question-type1-ui-sub-container-question-submit'>
                                    <Button2 width='100%'
                                             height='100%'
                                             idFor508='question-option-submit'
                                             onClick={() => {
                                                 onQuestionSubmitted()
                                             }}
                                             onRenderContent={() => {
                                                 return (
                                                     <p className='center-element black-text'>Submit</p>
                                                 )
                                             }}
                                             isSelected={false}
                                             isDisabled={selectedOptionIndices.length === 0}
                                             updateDisableOpacity={true}
                                            hoverBgColor={constants.design.hoverColor2}
                                            ariaLabel={'Submit'}></Button2>
                                </div>
                            </div>
                        );
                    }}></PopUp2>
            </div>

            <div className='question-type1-ui-replay-bttn'>
                <ReplayContentUI title='Replay Entire Cinematic' onReplayContentClicked={props.parameters.onReplayContentClicked}></ReplayContentUI>
            </div>
        </div>
    );

};

export interface QuestionType1UIConfig extends GeneralQuestionUIConfig {
    title: PageType;
    percentage?: number;
    subtitle: string;
    onReplayContentClicked?: () => void;
}

export default QuestionType1UI;